import styled, { Icon, IconScale, Scale, Typography } from '@secretescapes/falcon';

export const BadgesWrapper = styled('div')`
  display: flex;
`;

export const RefundableBadgeLink = styled(Typography)`
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.color.success70};
`;

export const ModalContentWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.l};
`;

export const Link = styled('a')`
  color: ${({ theme }) => theme.color.secondary60};
  cursor: pointer;
  text-decoration: underline;
`;

export const NonRefundableBadgeLink = styled(Typography)`
  text-decoration: underline;
  cursor: pointer;
  color: ${({ theme }) => theme.color.blackText};
`;

export const WrappedIcon = styled(Icon)`
  box-sizing: border-box;
  height: ${IconScale.m};
  width: ${IconScale.m};
  margin: 0 1px;
  display: flex;
`;
